import { axiosInstance, API_PREFIX, type ApiResponse } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type { KassaAcceptPayload, KassaItem, KassaListParams } from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/kassa`;

export const getList = async (params?: KassaListParams): Promise<ApiResponseList<KassaItem>> => {
  const { data } = await axiosInstance.get<ApiResponseList<KassaItem>>(`${BASE}/index`, { params });
  return data;
};

export const accept = async (payload: KassaAcceptPayload): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/accept`, payload);
  return data;
};
